module.exports = __webpack_public_path__ + "00_cheeks.b95dd33a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer3/00_cheeks.png
// module id = EDof
// module chunks = 0